import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig from '../useGetFetchConfig';

export const useDownloadTermsOfUsePdf = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useMutation(
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/terms-of-use/pdf-url`, fetchConfigGET);

      if (!res.ok) {
        throw new Error('Failed to fetch download URL');
      }

      const data: { downloadUrl: string } = await res.json();

      const link = document.createElement('a');
      link.href = data.downloadUrl;
      link.download = 'terms-of-use.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    {
      onError: () => {
        toast.error('Failed to download the terms of use PDF');
      },
    },
  );
};
